import React from 'react';

import { QuestionCircleOutlined as HelpOutlineIcon } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';

import PermissionHide from 'v2/components/Shared/PermissionHide';
import { Mask } from 'v2/components/Shared/ValuesVisibility';
import { numberToBRL } from 'v2/helpers/money';

import { ThemeColors } from './constants';
import type { Props } from './constants';

function ValueCard({
  id,
  title,
  isLoading,
  value,
  valueTheme,
  hint,
  isCtaDisabled = false,
  ctaCopy,
  ctaButtonTooltip,
  isTooltipOpen = undefined,
  ctaCallback,
  ctaAccessControl = '',
  bottomExtra
}: Props) {
  const valueClass = valueTheme === ThemeColors.SUCCESS ? 'text-success' : '';

  const renderCtaButton = () => {
    const ctaButton = () => (
      <Button
        className='min-h-0 min-w-0 px-2.5 py-0 text-[10px]! leading-[23px]'
        type='primary'
        onClick={!isCtaDisabled ? ctaCallback : undefined}
        disabled={isCtaDisabled}
        size='small'
      >
        {ctaCopy}
      </Button>
    );

    if (ctaButtonTooltip) {
      return (
        <Tooltip open={isTooltipOpen} title={ctaButtonTooltip} placement='top'>
          <span>{ctaButton()}</span>
        </Tooltip>
      );
    }

    return ctaButton();
  };

  return (
    <div id={id} className='flex h-full flex-col bg-[#f2f2f2] p-0.5 font-[Roboto,Helvetica_Neue,Arial,sans-serif]'>
      <div className='flex-1 rounded-[inherit] bg-white p-2'>
        <div className='mb-1.5 flex items-center justify-between'>
          <span className='pr-1.5 text-sm'>{title}</span>
          <Tooltip title={hint} placement='top' arrow>
            <HelpOutlineIcon style={{ fontSize: 18 }} />
          </Tooltip>
        </div>

        <div className='flex flex-wrap items-center justify-between'>
          <span className={valueClass}>
            <span className='text-[17px] leading-none font-bold'>
              <Mask>{!!isLoading || typeof value !== 'number' ? '-' : numberToBRL(value)}</Mask>
            </span>
          </span>

          {!!ctaCopy && !!ctaCallback && <PermissionHide action={ctaAccessControl}>{renderCtaButton()}</PermissionHide>}
        </div>
      </div>

      {!!bottomExtra && (
        <div className='text-grey-500 flex items-center px-2 py-[7px] text-[11px] [&_a]:flex [&_a]:items-center [&_a]:text-inherit'>
          {bottomExtra}
        </div>
      )}
    </div>
  );
}

export default ValueCard;
